import React from 'react';
import { useParams } from 'react-router-dom';
import AuthLayout from '../../layouts/AuthLayout/AuthLayout';
import MerchantPaymentForm from '../../components/forms/MerchantPaymentForm/MerchantPaymentForm';

const MerchantPayment = () => {

  const { uid } = useParams();

  return (
    <AuthLayout pageName="merchant-pay">
      <MerchantPaymentForm paymentRef={uid} />
    </AuthLayout>
  );
};

export default MerchantPayment;
